import { UPDATE_ENTRY_STRATEGY, UPDATE_ENTRY_STRATEGY_FAILURE, UPDATE_ENTRY_STRATEGY_SUCCESS } from './actionTypes';

export const updateEntryStrategy = ({ token, updatedBy, id, name, history }) => {
  return {
    type: UPDATE_ENTRY_STRATEGY,
    payload: { token, updatedBy, id, name, history },
  };
};

export const updateEntryStrategySuccess = (message) => {
  return {
    type: UPDATE_ENTRY_STRATEGY_SUCCESS,
    payload: { message },
  };
};

export const updateEntryStrategyFailure = (message) => {
  return {
    type: UPDATE_ENTRY_STRATEGY_FAILURE,
    payload: { message },
  };
};
